import TopStrip from '@/pages/home/components/TopStrip';
import Masthead from '@/pages/home/components/Masthead';
import HeroSplit from '@/pages/home/components/HeroSplit';
import BriefStream from '@/pages/home/components/BriefStream';
import HotRanking from '@/pages/home/components/HotRanking';
import EntryNav from '@/pages/home/components/EntryNav';
import TopicPicks from '@/pages/home/components/TopicPicks';
import StatsBar from '@/pages/home/components/StatsBar';
import EditorPicks from '@/pages/home/components/EditorPicks';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50 font-body text-foreground-950">
      <TopStrip />
      <Masthead />

      <main className="w-full flex-1">
        <HeroSplit />

        <section id="shortnews" className="w-full border-y border-background-200 bg-background-100/70">
          <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-10">
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
              <div className="lg:col-span-2">
                <BriefStream />
              </div>
              <div>
                <HotRanking />
              </div>
            </div>
          </div>
        </section>

        <EntryNav />
        <TopicPicks />
        <StatsBar />
        <EditorPicks />
      </main>

      <SiteFooter />
    </div>
  );
}